import { checkEnvironment } from '@saviynt/common';

const getListRowApiUrl = () => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/useraccess`;
};

export default getListRowApiUrl;
